import { render, staticRenderFns } from "./icon-logical-folder.vue?vue&type=template&id=f05e9a48&"
import script from "./icon-logical-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-logical-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports